import { render } from "./PassageRefWidget.vue?vue&type=template&id=68bf45fb&scoped=true"
import script from "./PassageRefWidget.vue?vue&type=script&lang=js"
export * from "./PassageRefWidget.vue?vue&type=script&lang=js"

import "./PassageRefWidget.vue?vue&type=style&index=0&id=68bf45fb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bf45fb"]])

export default __exports__